var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('o-grid',{class:[
    _vm.$s.Section,
    {
      [_vm.$s.bordered]: _vm.bordered,
    },
  ]},_vm._l((_vm.section),function(column,index){return _c('o-grid-item',{key:index,attrs:{"span":12,"tablet-landscape":_vm.desktopSpacing,"big-desktop":_vm.desktopSpacing}},[_c('feature-section-content',{attrs:{"column":column}})],1)}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }